import React, { useEffect } from 'react'
import { MetricTimeUnit } from 'enums'

import { createMetric } from 'utils/runSearchUtil'
import { getInsightContentData } from 'features/insightContent/asyncThunks'
import { getMetricSeries } from 'utils/measureTypeUtil'
import { getMeasureTypeByCountType } from 'components/insightContent/utils/utils'
import { CountTypeStrings } from 'enums/CountType'
import { useAppDispatch } from 'app/hooks'
import { InsightContentSettingType } from 'components/insightContent/types'
import { getSparklineMetricTimeUnit } from 'utils/sparklineMetricTimeUnit'
import InsightContentType from 'components/insightContent/enum/InsightContentType'
import useRefreshTimestamp from 'hooks/useRefreshTimestamp'

const createSearch = (
  detailSetting: InsightContentSettingType,
  countType: CountTypeStrings,
  forceNotScale?: boolean
) => {
  const { filter, precision, topicId, selectionFilter } = detailSetting
  if (!selectionFilter) {
    return null
  }

  const timeUnits = [MetricTimeUnit.ALL, getSparklineMetricTimeUnit(filter?.publishedDate)]
  const option = {
    forceNotScale: forceNotScale || false
  }
  const measure = getMeasureTypeByCountType(countType)

  return createMetric(
    -1,
    '',
    precision,
    [topicId],
    selectionFilter,
    getMetricSeries(measure),
    timeUnits,
    option
  )
}

const RunSearchEffect = ({
  detailSetting,
  countType,
  children,
  forceNotScale
}: {
  detailSetting: InsightContentSettingType
  countType: CountTypeStrings
  children: any
  forceNotScale?: boolean
}) => {
  const dispatch = useAppDispatch()
  const refreshTimestamp = useRefreshTimestamp()

  useEffect(() => {
    const searches = createSearch(detailSetting, countType, forceNotScale)

    dispatch(
      getInsightContentData({
        insightContentType: InsightContentType.NAME_MEASURE_BY,
        searches: [searches!],
        timestamp: refreshTimestamp
      })
    )
  }, [dispatch, detailSetting, countType, forceNotScale, refreshTimestamp])

  return <>{children}</>
}

export default RunSearchEffect
